var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z",
    fill: "url(#paint0_linear_514_902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.143,
    d: "M10.1058 16.2637C6.70476 16.2637 3.94768 13.5066 3.94768 10.1056C3.94768 6.70453 6.70476 3.94745 10.1058 3.94745C13.5068 3.94745 16.2639 6.70453 16.2639 10.1056C16.2639 13.5066 13.5068 16.2637 10.1058 16.2637Z",
    fill: "#F3F52D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.684,
    d: "M15.3161 11.5255C13.7465 11.5255 12.4742 10.2531 12.4742 8.68362C12.4742 7.11409 13.7465 5.84174 15.3161 5.84174C16.8856 5.84174 18.158 7.11409 18.158 8.68362C18.158 10.2531 16.8856 11.5255 15.3161 11.5255Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_514_902",
    x1: 14.304,
    y1: -0.72015,
    x2: 24.8907,
    y2: 13.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5612D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.bf20960d30434430fdf6a4a835f4a229.svg";
export { ForwardRef as ReactComponent };